import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MapLegendContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: theme.spacing(1),
  },
}));

interface MapLegendItemProps {
  backgroundColor: string;
}

export const MapLegendItem = styled(Box)<MapLegendItemProps>(({ theme, backgroundColor }) => ({
  width: '100%',
  maxWidth: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor,
  borderRadius: '999px',
  textAlign: 'center',
  padding: theme.spacing(1, 2),
}));
